export default "__VITE_ASSET__BnqALlk2__"